var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
var icons = {
    // eslint-disable-next-line quotes
    info: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Eregular/info-circle%3C/title%3E%3Cpath fill='XXXXX' d='M64 128C28.654 128 0 99.346 0 64 0 28.654 28.654 0 64 0c35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64zm0-8c30.928 0 56-25.072 56-56S94.928 8 64 8 8 33.072 8 64s25.072 56 56 56zm.5-96.25c3.333.167 6.125 1.375 8.375 3.625s3.375 5.083 3.375 8.5-1.125 6.25-3.375 8.5-5.083 3.375-8.5 3.375-6.25-1.125-8.5-3.375-3.375-5.083-3.375-8.5 1.125-6.25 3.375-8.5S61 23.917 64.5 23.75zm20 67.49c0 .558-.23 1.383-.546 1.842 0 0-.954 1.918-5.329 5.293S69 104 61 104c-4 0-7.75-1.125-10-3s-3.506-4.752-2.75-8.75C50 83 54.5 65 54.5 65c.333-2.5-.667-4.083-3-4.75l-4.275-1.018c-.538-.128-.975-.675-.975-1.231v-1.002c0-.552.45-.999 1-.999H71c1 0 1.792.417 2.375 1.25s.708 1.75.375 2.75c0 0-4.75 22-5.75 26-1.461 5.846.833 7.75 4 7.75 4-.167 7.083-1.083 9.25-2.75s2.512-2.066 2.512-2.066c.408-.378.738-.24.738.325v1.982z'  fill-rule='evenodd'/%3E%3C/svg%3E",
};
var getIcon = function (icon, size, fill) {
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var actions = {
    display: 'block',
    height: 32,
    padding: 0,
    float: 'right',
    fontSize: 0,
    marginTop: (4 + 2) * -1,
    marginRight: 8 * -1,
};
export var actionButton = {
    display: 'inline-block',
    borderLeft: "".concat('1px solid #cccccc'),
    marginLeft: '0px !important',
    marginRight: 0,
    fontSize: 'auto',
    height: 32,
    width: 32 - 1,
    color: '#222222',
    ':hover': {
        borderLeft: "".concat('1px solid #cccccc'),
        color: '#a6a6a6',
    },
    ':focus': {
        borderLeft: "".concat('1px solid #cccccc'),
        color: '#a6a6a6',
    },
};
export var actionButtonLeft = {
    borderRight: "".concat('1px solid #cccccc'),
    marginRight: '0px',
    marginLeft: 0,
    fontSize: 14,
    height: 32,
    width: 32 - 1,
    color: '#222222',
    ':hover': {
        borderRight: "".concat('1px solid #cccccc'),
        color: '#a6a6a6',
    },
    ':focus': {
        borderRight: "".concat('1px solid #cccccc'),
        color: '#a6a6a6',
    },
};
export var actionButtonIcon = {
    color: '#222222',
    fontSize: 14,
    left: 1,
    ':hover': {
        color: '#a6a6a6',
    },
};
export var actionsLeft = {
    float: 'left',
    marginLeft: 8 * -1,
    marginRight: 8,
};
export var buttonBorderNone = {
    borderLeft: 'none',
    borderRight: 'none',
};
export var disabled = {
    backgroundColor: '#eaeaea',
    color: '#a6a6a6',
    cursor: 'not-allowed',
};
export var footnote = __assign(__assign({}, reset), { display: 'block', fontSize: 12, paddingTop: 4 });
export var disabledFootnote = __assign({}, footnote);
export var error = {
    boxShadow: "0 0 0 1px ".concat('#c8102e'),
    border: "".concat(1, "px solid ").concat('#c8102e'),
    ':focus': {
        boxShadow: "0 0 0 1px ".concat('#c8102e'),
        border: "".concat(1, "px solid ").concat('#c8102e'),
    },
};
export var errorMessage = __assign(__assign({}, footnote), { color: '#c8102e' });
export var focus = {
    boxShadow: "0 0 5px ".concat('#1588af'),
    border: "".concat(1, "px solid ").concat('#1588af'),
};
export var infoIcon = __assign(__assign({}, getIcon(icons.info, 16, '#1588af')), { marginLeft: 8, marginTop: -2, verticalAlign: 'middle' });
export var input = __assign(__assign({}, reset), { backgroundColor: '#ffffff', border: '1px solid #cccccc', borderRadius: 2, boxSizing: 'border-box', display: 'block', fontSize: 14, outline: 'none', padding: "".concat(4 + 1, "px ").concat(8, "px ").concat(8 - 1, "px ").concat(8, "px"), position: 'relative', transition: 'box-shadow 0.3s ease-in-out', width: '100%', height: 32, '::placeholder': {
        color: '#a6a6a6',
    }, disabled: disabled, '[disabled]': disabled, ':focus': focus });
export var value = {
    appearance: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    lineHeight: '20px',
    boxSizing: 'border-box',
    display: 'block',
    margin: 0,
    padding: 0,
    outline: 'none',
    width: '100%',
    verticalAlign: 'top',
};
export var valueWrapper = {
    overflow: 'hidden',
    flex: 1,
};
export var responsive = (_a = {},
    _a["@media ".concat(mobile(700))] = {
        fontSize: 18,
        height: 48,
        padding: "".concat(12 - 1, "px ").concat(8, "px"),
    },
    _a);
export var responsiveInputValue = (_b = {},
    _b["@media ".concat(mobile(700))] = {
        lineHeight: 24,
    },
    _b);
export var label = __assign(__assign({}, reset), { display: 'block', fontSize: 14, fontWeight: 600, width: '100%', marginBottom: 4, em: {
        color: '#666666',
        fontStyle: 'normal',
        textTransform: 'lowercase',
    }, p: {
        fontStyle: 'normal',
        fontWeight: 400,
    } });
export var labelSide = __assign(__assign({}, label), { marginTop: 6 });
export var labelWrapperChildren = __assign(__assign({}, label), { marginTop: 0, marginBottom: 0 });
export var labelWrapChildren = {
    display: 'inline-flex',
    flexDirection: 'column',
    width: '100%',
};
export var labelWrapChildrenSide = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
};
var labelWrapSpan = {
    whiteSpace: 'nowrap',
};
export var labelContentSpanLeft = __assign(__assign({}, labelWrapSpan), { paddingRight: "".concat(16, "px !important") });
export var labelContentSpanRight = __assign(__assign({}, labelWrapSpan), { paddingLeft: "".concat(16, "px !important") });
export var labelContentSpanTop = __assign(__assign({}, labelWrapSpan), { paddingBottom: 4 });
export var validationLabel = {
    marginLeft: 4,
};
